import React from 'react';
import Icon from 'icon';
import s from './select.module.scss';

export default function SearchBar({ initialValue, option, setOption, children, ...props }) {


  return (
    <div className={s.select}>
      <select
        onChange={e => setOption(e.target.value)}
      >
        {children}
      </select>
    </div>
  );
}
